import { render, staticRenderFns } from "./OtsTipline.vue?vue&type=template&id=23af47b0&scoped=true&"
import script from "./OtsTipline.vue?vue&type=script&lang=js&"
export * from "./OtsTipline.vue?vue&type=script&lang=js&"
import style0 from "./OtsTipline.vue?vue&type=style&index=0&id=23af47b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af47b0",
  null
  
)

export default component.exports